import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useCurrentAccount } from '@/store/use-account-store';
import { abbrFromSym, imgFromSym } from '@/utils/token-symbol';
import { formatBigInt } from '@/utils/value-format';
import { cn } from '@/utils/cn';

type Props = {
  symbol: string;
};

export default function Symbol({ symbol }: Props) {
  const { t } = useTranslation();

  const { initMarginRatio, isLong } = useCurrentAccount((state) => ({
    initMarginRatio: state.positions[symbol].initMarginRatio,
    isLong: state.positions[symbol].isLong,
  }));

  return (
    <Link
      to={`/trade/${symbol}`}
      className="flex cursor-pointer items-center gap-3"
    >
      <img
        src={imgFromSym(symbol)}
        title={symbol}
        className="size-8 rounded-full object-contain"
      />

      <div>
        <div className="text-xl font-semibold">{abbrFromSym(symbol)}</div>

        <div className={cn('text-base', isLong ? 'text-green' : 'text-red')}>
          {isLong ? t('positionsTable.long') : t('positionsTable.short')}{' '}
          {formatBigInt(initMarginRatio ? (10n ** 6n / initMarginRatio) : 0n, 2n, {
            digits: 0,
            round: 'ceil',
            style: 'leverage',
          })}
        </div>
      </div>
    </Link>
  );
}

export const symbolAccessorFn = (symbol: string) => symbol;
